import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * SSO callback handler — receives tokens from Kombatix SSO redirect.
 * Exchanges external JWT for Firebase custom token and signs in.
 */
export default function AuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // TODO: Extract token from URL params, exchange for Firebase custom token
    // For now, redirect to dashboard.
    //
    // NOTE: this route is MOUNTED and reachable (`App.tsx` -> /auth/callback),
    // so an SSO redirect landing here today has its token silently discarded
    // and the user is bounced to `/` looking as though sign-in worked.
    //
    // `navigate` returns a promise in react-router v7; `void` marks the
    // fire-and-forget deliberately. Nothing depends on the navigation settling
    // and a browser has no container to freeze, so this is a genuine
    // fire-and-forget rather than the durability bug the rule usually catches.
    const timer = setTimeout(() => void navigate('/', { replace: true }), 2000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900 mx-auto" />
        <p className="mt-4 text-sm text-slate-500">Completing sign in...</p>
      </div>
    </div>
  );
}
